import { apiFetch } from '../utils/apiFetch';
import { API_CONFIG } from '../constants';
import { PatientResponse, PatientProfileResponse, CheckVitalsResponse } from '../dtos/patient';

export const fetchPatientById = async (patientId: number): Promise<PatientResponse> => {
    const response = await apiFetch({
        url: API_CONFIG.ENDPOINTS.PATIENT(patientId),
        method: 'GET',
        params: {
            patient_id: patientId,
        },
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch patient: ${response.status}`);
    }

    const data = await response.json();
    return Array.isArray(data) ? data[0] : data;
};

/**
 * Resolve the patient id for a user. The guest flow only knows the user id —
 * /mt-vmr/patient/profile?user_id=... returns a single-record list whose `id` is
 * the patient id the rest of the session needs.
 */
export const fetchPatientIdByUserId = async (userId: number): Promise<number> => {
    const response = await apiFetch({
        url: API_CONFIG.ENDPOINTS.PATIENT_PROFILE,
        method: 'GET',
        params: {
            user_id: userId
        },
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch patient for user ${userId}: ${response.status}`);
    }

    const data = (await response.json()) as PatientProfileResponse[];
    const patient = data?.[0];

    if (!patient) {
        throw new Error(`No patient found for user ${userId}`);
    }

    return patient.id;
};

export const checkVitals = async (sessionId: number): Promise<CheckVitalsResponse> => {
    const response = await apiFetch({
        url: API_CONFIG.ENDPOINTS.CHECK_VITALS,
        method: 'POST',
        body: { sessionId },
    });

    if (!response.ok) {
        throw new Error(`Failed to check vitals: ${response.status}`);
    }

    return response.json();
};
